"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectablePoint = void 0;
/**
 * 允许注入的点
 */
var InjectablePoint;
(function (InjectablePoint) {
    /**
     * 构建 OrderItem 时的注入点
     */
    InjectablePoint["OnBuildOrderItem"] = "BuildOrderItem";
    /**
     * 询价时的注入点
     */
    InjectablePoint["OnQueryPrice"] = "QueryPrice";
    /**
     * 下单时的注入点
     */
    InjectablePoint["OnCheckOrder"] = "CheckOrder";
})(InjectablePoint || (exports.InjectablePoint = InjectablePoint = {}));
